export default {"src":"/_next/static/media/NBA_live_banner.09fda7a3.gif","height":1084,"width":1182,"blurWidth":0,"blurHeight":0};